const { defineMessages } = require('@sm/intl');

const PRICING_DISCLAIMER = '[Type: String][Vis.: high] - A string in pricing footer disclaimer';

const COPY = defineMessages({
  AUDIENCE: {
    id: 'Pricing.Footer.Audience',
    defaultMessage: 'SurveyMonkey Audience',
    desc: '[Type: String][Vis.: high] - SurveyMonkey Audience',
  },
  BUY_RESPONSES: {
    id: 'Pricing.Footer.BuyResponses',
    defaultMessage: 'BUY TARGETED RESPONSES',
    desc: '[Type: Button][Vis.: high] - A button/link text on pricing footer',
  },
  ADVANCE_SURVEY: {
    id: 'Pricing.Footer.AdvanceSurvey',
    defaultMessage: 'Advanced survey design and analysis features are included in the price of your Audience project.',
    desc: '[Type: String][Vis.: high] - A string above pricing footer list',
  },
  TARGET_PEOPLE: {
    id: 'Pricing.Footer.TargetPeople',
    defaultMessage:
      'Target the types of people you want to hear from based on specific attributes, like country, gender, age, income, employment status, and more.',
    desc: '[Type: String][Vis.: high] - A string above pricing footer cta',
  },
  SURVEY_RESPONSES: {
    id: 'Pricing.Footer.SurveyResponses',
    defaultMessage: 'Get survey responses from around the world in minutes with',
    desc: '[Type: String][Vis.: high] - A string in pricing footer below header',
  },
  PAID_FEATURES: {
    id: 'Pricing.Footer.PaidFeatures',
    defaultMessage: 'SurveyMonkey Audience includes access to Paid Features',
    desc: '[Type: Header][Vis.: high] - A string in pricing footer header',
  },
  DISPLAYED_PRICING: {
    id: 'Pricing.Footer.DisplayedPricingDisclaiimer',
    defaultMessage:
      '*Displayed pricing represents a {teamsMinimumDiscount}% or more savings per user per month compared to individual Advantage and Premier plans',
    desc: PRICING_DISCLAIMER,
  },
  PER_ADDITIONAL_RESPONSE: {
    id: 'Pricing.Footer.PerAddlResponseDisclaiimer',
    defaultMessage: '**{overageCost} per additional response. SurveyMonkey Audience responses sold separately',
    desc: PRICING_DISCLAIMER,
  },
  ADD_ON_FEATURES: {
    id: 'Pricing.Footer.AddOnFeatureseDisclaiimer',
    defaultMessage: '***Add-on features available with Enterprise plan must be purchased separately',
    desc: PRICING_DISCLAIMER,
  },
  BASICS: {
    id: 'Pricing.Footer.Basics',
    defaultMessage: 'Just need the basics?',
    desc: '[Type: String][Vis.: high] - A string asking if the user is only interested in the basics',
  },
  GET_STARTED: {
    id: 'Pricing.Footer.GetStarted',
    defaultMessage: 'Get started for free.',
    desc: '[Type: Link][Vis.: high] - A link to sign up page ',
  },
  ALL_FEATURES: {
    id: 'Pricing.Footer.AllFeatures',
    defaultMessage: 'SEE ALL PLAN FEATURES',
    desc: '[Type: Link][Vis.: high] - A link to details page',
  },
  MORE: {
    id: 'Pricing.Footer.More',
    defaultMessage: 'More about plans and pricing',
    desc: '[Type: Header][Vis.: high] - More info about plans and pricing',
  },
  SURVEYMONKEY_COST: {
    id: 'Pricing.Footer.SurveyMonkeyCost',
    defaultMessage: 'How much does SurveyMonkey cost?',
    desc: '[Type: Title][Vis.: high] - A string for how much SurveyMonkey cost per plan',
  },
  SEE_PRICING: {
    id: 'Pricing.Footer.SeePricing',
    defaultMessage: 'See pricing',
    desc: '[Type: Link][Vis.: high] - A link to pricing',
  },
  SPECIAL_PRICING_FOR_EDUCATORS_FAQ: {
    id: 'Pricing.Footer.SpecialPricingForEducatorsFaq',
    defaultMessage: 'Do you offer special pricing for students or educators?',
    desc: '[Type: Title][Vis.: high] - A string for special pricing for educators and students faq',
  },
  SPECIAL_PRICING_FOR_EDUCATORS_ANSWER: {
    id: 'Pricing.Footer.SpecialPricingForEducatorsAnswer',
    defaultMessage: 'Yes! We offer discounted pricing for students and educators.',
    desc: '[Type: String][Vis.: high] - A string for special pricing for educators and students answer',
  },
  DISCOUNTS_FOR_TEAMS_FAQ: {
    id: 'Pricing.Footer.DiscountForTeamsFaq',
    defaultMessage: 'Do you offer discounts for teams?',
    desc: '[Type: Title][Vis.: high] - A string for discounts for teams faq',
  },
  DISCOUNTS_FOR_TEAMS_ANSWER: {
    id: 'Pricing.Footer.DiscountForTeamsAnswer',
    defaultMessage:
      'We offer discounts when you sign up for team plans that include 3 or more people. With Team Advantage and Team Premier plans, you’ll save {teamsMinimumDiscount}% or more over individual plans and get access to additional collaboration features.',
    desc: '[Type: String][Vis.: high] - A string for discounts for teams answer',
  },
  CORPORATE_PLANS_FAQ: {
    id: 'Pricing.Footer.CorporatePlansFaq',
    defaultMessage: 'Do you offer plans for corporate needs?',
    desc: '[Type: Title][Vis.: high] - A string for corporate plans faq',
  },
  CORPORATE_PLANS_ANSWER: {
    id: 'Pricing.Footer.CorporatePlansAnswer',
    defaultMessage:
      'Our Enterprise plans offer HIPAA compliance, advanced security, and admin features for increased governance and control.',
    desc: '[Type: String][Vis.: high] - A string for corporate plans answer',
  },
  CONTACT_SALES: {
    id: 'Pricing.Footer.ContactSales',
    defaultMessage: 'Contact sales',
    desc: '[Type: Link][Vis.: high] - A link to contact sales',
  },
  BASIC_FREEE: {
    id: 'Pricing.Footer.BasicPlanFree',
    defaultMessage: 'The Basic plan is FREE.',
    desc: '[Type: String][Vis.: high] - A string containing the Basic plan price',
  },
  PER_USER: {
    id: 'Pricing.Footer.PerUser',
    defaultMessage: 'per user',
    desc: '[Type: String][Vis.: high] - A string for plans billed per user',
  },
  BILLED_ANNUALLY: {
    id: 'Pricing.Footer.BilledAnnually',
    defaultMessage: 'billed annually',
    desc: '[Type: String][Vis.: high] - A string for plans billed annually',
  },
  PLAN_PRICE: {
    id: 'Pricing.Footer.PlanPrice',
    defaultMessage: `The {packageName} plan costs {amount} a month{term}.`,
    desc: '[Type: String][Vis.: high] - A string for dynamically priced plans',
  },

  // FEATURE  COPY FOR AUDIENCE MODULE
  AUDIENCE_NUMBER_OF_SURVEYS: {
    id: 'Pricing.Footer.Audience.NumberOfSurveys',
    defaultMessage: 'Unlimited number of surveys',
    desc: '[Type: String][Vis.: high] - An audience surveys feature string',
  },
  AUDIENCE_QUESTIONS_PER_SURVEY: {
    id: 'Pricing.Footer.Audience.QuestionsPerSurvey',
    defaultMessage: '50 questions per survey',
    desc: '[Type: String][Vis.: high] - An audience surveys feature string',
  },
  AUDIENCE_UNLIMITED_RESPONSES: {
    id: 'Pricing.Footer.Audience.UnlimitedResponses',
    defaultMessage: 'Unlimited responses',
    desc: '[Type: String][Vis.: high] - An audience surveys feature string',
  },
  AUDIENCE_EMAIL_SUPPORT: {
    id: 'Pricing.Footer.Audience.EmailSupport',
    defaultMessage: '24/7 customer support via email',
    desc: '[Type: String][Vis.: high] - An audience surveys feature string',
  },
  AUDIENCE_CUSTOMIZATION: {
    id: 'Pricing.Footer.Audience.SurveyCustomization',
    defaultMessage: 'Custom colors & survey URL',
    desc: '[Type: String][Vis.: high] - An audience surveys feature string',
  },
  AUDIENCE_DATA_EXPORTS: {
    id: 'Pricing.Footer.Audience.DataExports',
    defaultMessage: 'Data exports (CSV, PDF, PPT, XLS)',
    desc: '[Type: String][Vis.: high] - An audience surveys feature string',
  },
  AUDIENCE_SKIP_LOGIC: {
    id: 'Pricing.Footer.Audience.SkipLogic',
    defaultMessage: 'Skip logic',
    desc: '[Type: String][Vis.: high] - An audience surveys feature string',
  },
  AUDIENCE_PIPING: {
    id: 'Pricing.Footer.Audience.QuestionAnswerPiping',
    defaultMessage: 'Question & answer piping',
    desc: '[Type: String][Vis.: high] - An audience surveys feature string',
  },
  AUDIENCE_FILE_UPLOAD: {
    id: 'Pricing.Footer.Audience.FileUpload',
    defaultMessage: 'File upload',
    desc: '[Type: String][Vis.: high] - An audience surveys feature string',
  },
  AUDIENCE_A_B_TESTING: {
    id: 'Pricing.Footer.Audience.ABTesting',
    defaultMessage: 'A/B test text and images',
    desc: '[Type: String][Vis.: high] - An audience surveys feature string',
  },
  AUDIENCE_HIDE_FOOTER: {
    id: 'Pricing.Footer.Audience.HideFooter',
    defaultMessage: 'Hide SurveyMonkey footer',
    desc: '[Type: String][Vis.: high] - An audience surveys feature string',
  },
  AUDIENCE_MULTILINGUAL: {
    id: 'Pricing.Footer.Audience.MultilingualSurveys',
    defaultMessage: 'Multilingual surveys',
    desc: '[Type: String][Vis.: high] - An audience surveys feature string',
  },
  TEAMS_DISCOUNT_DISCLAIMER: {
    id: 'ChooseCollector.Disclaimer.TeamsDiscount',
    defaultMessage:
      '\u{00B9} Offer is invite-only, non-transferrable, and limited to the purchase of an annual plan. Offer expires May 31, 2023. Not applicable on subscription renewals.',
    description: '[Type: Label][Vis.: high] - add on features footnote in disclaimer',
  },
});

export default COPY;
